/**
 * @generated SignedSource<<20e83b57d20d5e5d307bf2c5a07f4ece>>
 * @relayHash 57512e908279650f89aa504049505f3e
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 57512e908279650f89aa504049505f3e

import type { ConcreteRequest } from 'relay-runtime';
export type CommentAuthorAssociation = "COLLABORATOR" | "CONTRIBUTOR" | "FIRST_TIMER" | "FIRST_TIME_CONTRIBUTOR" | "MANNEQUIN" | "MEMBER" | "NONE" | "OWNER" | "%future added value";
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type LockReason = "OFF_TOPIC" | "RESOLVED" | "SPAM" | "TOO_HEATED" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type ReactionContent = "CONFUSED" | "EYES" | "HEART" | "HOORAY" | "LAUGH" | "ROCKET" | "THUMBS_DOWN" | "THUMBS_UP" | "%future added value";
export type UserBlockDuration = "ONE_DAY" | "ONE_MONTH" | "ONE_WEEK" | "PERMANENT" | "THREE_DAYS" | "%future added value";
export type useTimelineItemsBackQuery$variables = {
  count: number;
  cursor?: string | null | undefined;
  id: string;
};
export type useTimelineItemsBackQuery$data = {
  readonly node: {
    readonly backTimelineItems?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly __id: string;
          readonly actor?: {
            readonly __typename: string;
            readonly avatarUrl: string;
            readonly displayName?: string;
            readonly id: string;
            readonly isAgent?: boolean;
            readonly isCopilot?: boolean;
            readonly login: string;
            readonly name?: string | null | undefined;
            readonly profileResourcePath: string | null | undefined;
          } | null | undefined;
          readonly assignee?: {
            readonly __typename?: string;
            readonly displayName?: string;
            readonly id?: string;
            readonly isAgent?: boolean;
            readonly isCopilot?: boolean;
            readonly login?: string;
            readonly name?: string | null | undefined;
            readonly resourcePath?: string;
          } | null | undefined;
          readonly author?: {
            readonly __typename: string;
            readonly avatarUrl: string;
            readonly id: string;
            readonly login: string;
            readonly name?: string | null | undefined;
            readonly profileUrl: string | null | undefined;
          } | null | undefined;
          readonly authorAssociation?: CommentAuthorAssociation;
          readonly authorToRepoOwnerSponsorship?: {
            readonly createdAt: string;
            readonly isActive: boolean;
          } | null | undefined;
          readonly blockDuration?: UserBlockDuration;
          readonly blockedIssue?: {
            readonly __typename: "Issue";
            readonly id: string;
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly stateReason: IssueStateReason | null | undefined;
            readonly titleHTML: string;
            readonly url: string;
          } | null | undefined;
          readonly blockedUser?: {
            readonly login: string;
            readonly name: string | null | undefined;
          } | null | undefined;
          readonly blockingIssue?: {
            readonly __typename: "Issue";
            readonly id: string;
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly stateReason: IssueStateReason | null | undefined;
            readonly titleHTML: string;
            readonly url: string;
          } | null | undefined;
          readonly body?: string;
          readonly bodyHTML?: string;
          readonly bodyVersion?: string;
          readonly canonical?: {
            readonly __typename: "Issue";
            readonly id: string;
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly stateReason: IssueStateReason | null | undefined;
            readonly titleHTML: string;
            readonly url: string;
          } | {
            readonly __typename: "PullRequest";
            readonly id: string;
            readonly isDraft: boolean;
            readonly isInMergeQueue: boolean;
            readonly number: number;
            readonly pullTitleHTML: string;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly state: PullRequestState;
            readonly url: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly closer?: {
            readonly __typename: "Commit";
            readonly abbreviatedOid: string;
            readonly repository: {
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly url: string;
          } | {
            readonly __typename: "ProjectV2";
            readonly title: string;
            readonly url: string;
          } | {
            readonly __typename: "PullRequest";
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly url: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly closingProjectItemStatus?: string | null | undefined;
          readonly color?: string | null | undefined;
          readonly commit?: {
            readonly abbreviatedOid: string;
            readonly message: string;
            readonly messageBodyHTML: string;
            readonly messageHeadlineHTML: string;
            readonly repository: {
              readonly defaultBranch: string;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly url: string;
          } | null | undefined;
          readonly createdAt?: string;
          readonly createdViaEmail?: boolean;
          readonly currentTitle?: string;
          readonly databaseId?: number | null | undefined;
          readonly deletedCommentAuthor?: {
            readonly __typename: string;
            readonly login: string;
            readonly name?: string | null | undefined;
          } | null | undefined;
          readonly discussion?: {
            readonly number: number;
            readonly url: string;
          } | null | undefined;
          readonly duplicate?: {
            readonly __typename: "Issue";
            readonly id: string;
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly stateReason: IssueStateReason | null | undefined;
            readonly titleHTML: string;
            readonly url: string;
          } | {
            readonly __typename: "PullRequest";
            readonly id: string;
            readonly isDraft: boolean;
            readonly isInMergeQueue: boolean;
            readonly number: number;
            readonly pullTitleHTML: string;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly state: PullRequestState;
            readonly url: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly duplicateOf?: {
            readonly __typename: "Issue";
            readonly id: string;
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly stateReason: IssueStateReason | null | undefined;
            readonly titleHTML: string;
            readonly url: string;
          } | {
            readonly __typename: "PullRequest";
            readonly id: string;
            readonly isDraft: boolean;
            readonly isInMergeQueue: boolean;
            readonly number: number;
            readonly pullTitleHTML: string;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly state: PullRequestState;
            readonly url: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly fromRepository?: {
            readonly nameWithOwner: string;
            readonly url: string;
          } | null | undefined;
          readonly id?: string;
          readonly innerSource?: {
            readonly __typename: "Issue";
            readonly id: string;
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly stateReason: IssueStateReason | null | undefined;
            readonly titleHTML: string;
            readonly url: string;
          } | {
            readonly __typename: "PullRequest";
            readonly id: string;
            readonly isDraft: boolean;
            readonly isInMergeQueue: boolean;
            readonly number: number;
            readonly pullTitleHTML: string;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly state: PullRequestState;
            readonly url: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          };
          readonly intent?: {
            readonly rationale: string | null | undefined;
          } | null | undefined;
          readonly isCanonicalOfClosedDuplicate?: boolean | null | undefined;
          readonly isHidden?: boolean;
          readonly issue?: {
            readonly author: {
              readonly login: string;
            } | null | undefined;
            readonly databaseId: number | null | undefined;
            readonly id: string;
            readonly locked: boolean;
            readonly number: number;
          };
          readonly issueComment?: {
            readonly databaseId: number | null | undefined;
            readonly id: string;
            readonly url: string;
          } | null | undefined;
          readonly issueField?: {
            readonly dataType?: IssueFieldDataType;
            readonly name?: string;
          } | null | undefined;
          readonly issueType?: {
            readonly color: IssueTypeColor;
            readonly name: string;
          } | null | undefined;
          readonly label?: {
            readonly color: string;
            readonly description: string | null | undefined;
            readonly id: string;
            readonly name: string;
            readonly nameHTML: string;
          };
          readonly lastEditedAt?: string | null | undefined;
          readonly lastUserContentEdit?: {
            readonly editor: {
              readonly login: string;
              readonly url: string;
            } | null | undefined;
          } | null | undefined;
          readonly lockReason?: LockReason | null | undefined;
          readonly milestone?: {
            readonly id: string;
            readonly url: string;
          } | null | undefined;
          readonly milestoneTitle?: string;
          readonly minimizedReason?: string | null | undefined;
          readonly newColor?: string | null | undefined;
          readonly newOptions?: ReadonlyArray<{
            readonly color: string | null | undefined;
            readonly name: string;
          }> | null | undefined;
          readonly newValue?: string | null | undefined;
          readonly options?: ReadonlyArray<{
            readonly color: string | null | undefined;
            readonly name: string;
          }> | null | undefined;
          readonly parent?: {
            readonly __typename: "Issue";
            readonly databaseId: number | null | undefined;
            readonly id: string;
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly stateReason: IssueStateReason | null | undefined;
            readonly titleHTML: string;
            readonly url: string;
          } | null | undefined;
          readonly pendingBlock?: boolean | null | undefined;
          readonly pendingMinimizeReason?: string | null | undefined;
          readonly pendingUnblock?: boolean | null | undefined;
          readonly pinnedBy?: {
            readonly login: string;
          } | null | undefined;
          readonly prevIssueType?: {
            readonly color: IssueTypeColor;
            readonly name: string;
          } | null | undefined;
          readonly previousStatus?: string;
          readonly previousTitle?: string;
          readonly project?: {
            readonly title: string;
            readonly url: string;
          } | null | undefined;
          readonly reactionGroups?: ReadonlyArray<{
            readonly content: ReactionContent;
            readonly reactors: {
              readonly nodes: ReadonlyArray<{
                readonly __typename: "Bot";
                readonly displayName: string;
                readonly isAgent: boolean;
                readonly isCopilot: boolean;
                readonly login: string;
              } | {
                readonly __typename: "Mannequin";
                readonly login: string;
              } | {
                readonly __typename: "Organization";
                readonly login: string;
              } | {
                readonly __typename: "User";
                readonly login: string;
              } | {
                // This will never be '%other', but we need some
                // value in case none of the concrete values match.
                readonly __typename: "%other";
              } | null | undefined> | null | undefined;
              readonly totalCount: number;
            };
            readonly viewerHasReacted: boolean;
          }> | null | undefined;
          readonly referencedAt?: string;
          readonly repository?: {
            readonly databaseId: number | null | undefined;
            readonly id: string;
            readonly isPrivate: boolean;
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly id: string;
              readonly login: string;
              readonly url: string;
            };
            readonly slashCommandsEnabled: boolean;
            readonly viewerCanCreateIssues: boolean;
          };
          readonly showSpammyBadge?: boolean;
          readonly source?: {
            readonly __typename: string;
          };
          readonly stateReason?: IssueStateReason | null | undefined;
          readonly status?: string;
          readonly subIssue?: {
            readonly __typename: "Issue";
            readonly databaseId: number | null | undefined;
            readonly id: string;
            readonly number: number;
            readonly repository: {
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly stateReason: IssueStateReason | null | undefined;
            readonly titleHTML: string;
            readonly url: string;
          } | null | undefined;
          readonly subject?: {
            readonly __typename: "PullRequest";
            readonly isDraft: boolean;
            readonly isInMergeQueue: boolean;
            readonly number: number;
            readonly repository: {
              readonly name: string;
              readonly owner: {
                readonly login: string;
              };
            };
            readonly state: PullRequestState;
            readonly title: string;
            readonly url: string;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          };
          readonly url?: string;
          readonly value?: string | null | undefined;
          readonly viaApp?: {
            readonly name: string;
            readonly url: string;
          } | null | undefined;
          readonly viewerCanBlockFromOrg?: boolean;
          readonly viewerCanBlockPersonally?: boolean;
          readonly viewerCanDelete?: boolean;
          readonly viewerCanMinimize?: boolean;
          readonly viewerCanPin?: boolean;
          readonly viewerCanReadUserContentEdits?: boolean;
          readonly viewerCanReport?: boolean;
          readonly viewerCanReportToMaintainer?: boolean;
          readonly viewerCanUnblockFromOrg?: boolean;
          readonly viewerCanUnblockPersonally?: boolean;
          readonly viewerCanUndo?: boolean;
          readonly viewerCanUnminimize?: boolean;
          readonly viewerCanUnpin?: boolean;
          readonly viewerCanUpdate?: boolean;
          readonly viewerDidAuthor?: boolean;
          readonly willCloseSubject?: boolean;
          readonly willCloseTarget?: boolean;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly startCursor: string | null | undefined;
      };
      readonly totalCount: number;
    };
  } | null | undefined;
};
export type useTimelineItemsBackQuery = {
  response: useTimelineItemsBackQuery$data;
  variables: useTimelineItemsBackQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "visibleEventsOnly",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = [
  (v15/*: any*/)
],
v17 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "User",
  "abstractKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v16/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": 64
            }
          ],
          "kind": "ScalarField",
          "name": "avatarUrl",
          "storageKey": "avatarUrl(size:64)"
        },
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profileResourcePath",
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/)
          ],
          "type": "Bot",
          "abstractKey": null
        },
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "TimelineEvent",
  "abstractKey": "__isTimelineEvent"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v22 = [
  (v11/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorAssociation",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDelete",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanMinimize",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnminimize",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReport",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReportToMaintainer",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanBlockFromOrg",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnblockFromOrg",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanBlockPersonally",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnblockPersonally",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPin",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnpin",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minimizedReason",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSpammyBadge",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdViaEmail",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReadUserContentEdits",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastEditedAt",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v49 = {
  "alias": "isHidden",
  "args": null,
  "kind": "ScalarField",
  "name": "isMinimized",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanCreateIssues",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slashCommandsEnabled",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasReacted",
  "storageKey": null
},
v57 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v58 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "User",
  "abstractKey": null
},
v59 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v60 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "Organization",
  "abstractKey": null
},
v61 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v62 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingMinimizeReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingBlock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingUnblock",
      "storageKey": null
    }
  ]
},
v63 = [
  (v7/*: any*/)
],
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseTarget",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referencedAt",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v15/*: any*/),
    (v51/*: any*/),
    (v68/*: any*/)
  ],
  "storageKey": null
},
v70 = {
  "alias": "pullTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v74 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v66/*: any*/),
      (v27/*: any*/),
      (v23/*: any*/),
      (v67/*: any*/),
      (v69/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v70/*: any*/),
      (v27/*: any*/),
      (v23/*: any*/),
      (v71/*: any*/),
      (v72/*: any*/),
      (v73/*: any*/),
      (v69/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameHTML",
      "storageKey": null
    },
    (v15/*: any*/),
    (v75/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rationale",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    (v76/*: any*/),
    (v10/*: any*/),
    (v77/*: any*/)
  ],
  "type": "LabeledEvent",
  "abstractKey": null
},
v79 = {
  "kind": "InlineFragment",
  "selections": [
    (v76/*: any*/),
    (v10/*: any*/)
  ],
  "type": "UnlabeledEvent",
  "abstractKey": null
},
v80 = {
  "kind": "InlineFragment",
  "selections": (v22/*: any*/),
  "type": "Actor",
  "abstractKey": "__isActor"
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v82 = [
  (v10/*: any*/),
  (v7/*: any*/),
  (v11/*: any*/),
  (v81/*: any*/),
  (v15/*: any*/)
],
v83 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v81/*: any*/),
  (v15/*: any*/)
],
v84 = {
  "kind": "InlineFragment",
  "selections": (v83/*: any*/),
  "type": "User",
  "abstractKey": null
},
v85 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v81/*: any*/),
    (v12/*: any*/),
    (v14/*: any*/),
    (v13/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v86 = {
  "kind": "InlineFragment",
  "selections": (v83/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v87 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v81/*: any*/)
  ],
  "type": "Organization",
  "abstractKey": null
},
v88 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "milestoneTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v27/*: any*/)
    ],
    "storageKey": null
  }
],
v89 = {
  "kind": "InlineFragment",
  "selections": (v88/*: any*/),
  "type": "MilestonedEvent",
  "abstractKey": null
},
v90 = {
  "kind": "InlineFragment",
  "selections": (v88/*: any*/),
  "type": "DemilestonedEvent",
  "abstractKey": null
},
v91 = [
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  }
],
v92 = {
  "kind": "InlineFragment",
  "selections": (v91/*: any*/),
  "type": "IssueFieldText",
  "abstractKey": null
},
v93 = {
  "kind": "InlineFragment",
  "selections": (v91/*: any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v94 = {
  "kind": "InlineFragment",
  "selections": (v91/*: any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v95 = {
  "kind": "InlineFragment",
  "selections": (v91/*: any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v96 = {
  "kind": "InlineFragment",
  "selections": (v91/*: any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v92/*: any*/),
    (v93/*: any*/),
    (v94/*: any*/),
    (v95/*: any*/),
    (v96/*: any*/)
  ],
  "storageKey": null
},
v98 = [
  (v15/*: any*/),
  (v75/*: any*/)
],
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldTimelineOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": (v98/*: any*/),
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newColor",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldTimelineOption",
  "kind": "LinkedField",
  "name": "newOptions",
  "plural": true,
  "selections": (v98/*: any*/),
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newValue",
  "storageKey": null
},
v104 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v27/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  }
],
v105 = {
  "kind": "InlineFragment",
  "selections": (v104/*: any*/),
  "type": "IssueCommentPinnedEvent",
  "abstractKey": null
},
v106 = {
  "kind": "InlineFragment",
  "selections": (v104/*: any*/),
  "type": "IssueCommentUnpinnedEvent",
  "abstractKey": null
},
v107 = [
  (v10/*: any*/)
],
v108 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "SubscribedEvent",
  "abstractKey": null
},
v109 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "UnsubscribedEvent",
  "abstractKey": null
},
v110 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "MentionedEvent",
  "abstractKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingProjectItemStatus",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v113 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    (v112/*: any*/)
  ],
  "type": "ProjectV2",
  "abstractKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v68/*: any*/)
  ],
  "storageKey": null
},
v116 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "ReopenedEvent",
  "abstractKey": null
},
v117 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockReason",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "type": "LockedEvent",
  "abstractKey": null
},
v118 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "UnlockedEvent",
  "abstractKey": null
},
v119 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "PinnedEvent",
  "abstractKey": null
},
v120 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "UnpinnedEvent",
  "abstractKey": null
},
v121 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previousTitle",
      "storageKey": null
    }
  ],
  "type": "RenamedTitleEvent",
  "abstractKey": null
},
v122 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v66/*: any*/),
  (v27/*: any*/),
  (v23/*: any*/),
  (v67/*: any*/),
  (v69/*: any*/)
],
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v122/*: any*/),
  "storageKey": null
},
v124 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v122/*: any*/),
    "storageKey": null
  }
],
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockDuration",
  "storageKey": null
},
v126 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v66/*: any*/),
  (v27/*: any*/),
  (v23/*: any*/),
  (v67/*: any*/),
  (v69/*: any*/),
  (v8/*: any*/)
],
v127 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v126/*: any*/),
    "storageKey": null
  }
],
v128 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v126/*: any*/),
    "storageKey": null
  }
],
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseSubject",
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageHeadlineHTML",
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageBodyHTML",
  "storageKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultBranch",
  "storageKey": null
},
v134 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v112/*: any*/),
          (v27/*: any*/),
          (v23/*: any*/),
          (v71/*: any*/),
          (v72/*: any*/),
          (v73/*: any*/),
          (v115/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v135 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v74/*: any*/),
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUndo",
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v112/*: any*/),
    (v27/*: any*/)
  ],
  "storageKey": null
},
v139 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousStatus",
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v141 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "ConvertedFromDraftEvent",
  "abstractKey": null
},
v142 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v98/*: any*/),
  "storageKey": null
},
v143 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v144 = [
  (v7/*: any*/),
  (v11/*: any*/),
  (v10/*: any*/)
],
v145 = {
  "kind": "InlineFragment",
  "selections": (v107/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v146 = [
  (v7/*: any*/),
  (v145/*: any*/)
],
v147 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v144/*: any*/),
  "storageKey": null
},
v148 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v15/*: any*/),
    (v51/*: any*/),
    (v147/*: any*/)
  ],
  "storageKey": null
},
v149 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v66/*: any*/),
      (v27/*: any*/),
      (v23/*: any*/),
      (v67/*: any*/),
      (v148/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v70/*: any*/),
      (v27/*: any*/),
      (v23/*: any*/),
      (v71/*: any*/),
      (v72/*: any*/),
      (v73/*: any*/),
      (v148/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  },
  (v145/*: any*/)
],
v150 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v92/*: any*/),
    (v93/*: any*/),
    (v94/*: any*/),
    (v95/*: any*/),
    (v96/*: any*/),
    (v145/*: any*/)
  ],
  "storageKey": null
},
v151 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v147/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v152 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v66/*: any*/),
  (v27/*: any*/),
  (v23/*: any*/),
  (v67/*: any*/),
  (v148/*: any*/)
],
v153 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v152/*: any*/),
  "storageKey": null
},
v154 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v152/*: any*/),
    "storageKey": null
  }
],
v155 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v66/*: any*/),
  (v27/*: any*/),
  (v23/*: any*/),
  (v67/*: any*/),
  (v148/*: any*/),
  (v8/*: any*/)
],
v156 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v155/*: any*/),
    "storageKey": null
  }
],
v157 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v155/*: any*/),
    "storageKey": null
  }
],
v158 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v112/*: any*/),
          (v27/*: any*/),
          (v23/*: any*/),
          (v71/*: any*/),
          (v72/*: any*/),
          (v73/*: any*/),
          (v151/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v145/*: any*/)
    ],
    "storageKey": null
  }
],
v159 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v149/*: any*/),
  "storageKey": null
},
v160 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v112/*: any*/),
    (v27/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v161 = [
  (v15/*: any*/),
  (v75/*: any*/),
  (v10/*: any*/)
],
v162 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v161/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTimelineItemsBackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "backTimelineItems",
                "args": (v4/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Issue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": (v22/*: any*/),
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v10/*: any*/),
                                  (v7/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              (v27/*: any*/),
                              (v9/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "App",
                                "kind": "LinkedField",
                                "name": "viaApp",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsorship",
                                "kind": "LinkedField",
                                "name": "authorToRepoOwnerSponsorship",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v43/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*: any*/),
                              (v45/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserContentEdit",
                                "kind": "LinkedField",
                                "name": "lastUserContentEdit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "editor",
                                    "plural": false,
                                    "selections": [
                                      (v27/*: any*/),
                                      (v11/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "pinnedBy",
                                "plural": false,
                                "selections": (v22/*: any*/),
                                "storageKey": null
                              },
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v51/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReactionGroup",
                                "kind": "LinkedField",
                                "name": "reactionGroups",
                                "plural": true,
                                "selections": [
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v57/*: any*/),
                                    "concreteType": "ReactorConnection",
                                    "kind": "LinkedField",
                                    "name": "reactors",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v58/*: any*/),
                                          (v59/*: any*/),
                                          (v60/*: any*/),
                                          (v61/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "reactors(first:5)"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v62/*: any*/)
                            ],
                            "type": "IssueComment",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v63/*: any*/),
                                "storageKey": null
                              },
                              (v64/*: any*/),
                              (v65/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": "innerSource",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v74/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CrossReferencedEvent",
                            "abstractKey": null
                          },
                          (v78/*: any*/),
                          (v79/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v80/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v82/*: any*/),
                                    "type": "User",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v82/*: any*/),
                                    "type": "Mannequin",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/),
                                      (v7/*: any*/),
                                      (v11/*: any*/),
                                      (v81/*: any*/)
                                    ],
                                    "type": "Organization",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/),
                                      (v7/*: any*/),
                                      (v11/*: any*/),
                                      (v81/*: any*/),
                                      (v12/*: any*/),
                                      (v14/*: any*/),
                                      (v13/*: any*/)
                                    ],
                                    "type": "Bot",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v77/*: any*/)
                            ],
                            "type": "AssignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v84/*: any*/),
                                  (v85/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v80/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "UnassignedEvent",
                            "abstractKey": null
                          },
                          (v89/*: any*/),
                          (v90/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v97/*: any*/),
                              (v99/*: any*/),
                              (v100/*: any*/),
                              (v75/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "IssueFieldAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v97/*: any*/),
                              (v101/*: any*/),
                              (v102/*: any*/),
                              (v103/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "IssueFieldChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v97/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "IssueFieldRemovedEvent",
                            "abstractKey": null
                          },
                          (v105/*: any*/),
                          (v106/*: any*/),
                          (v108/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v67/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicateOf",
                                "plural": false,
                                "selections": (v74/*: any*/),
                                "storageKey": null
                              },
                              (v111/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "closer",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v113/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v27/*: any*/),
                                      (v23/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v15/*: any*/),
                                          (v68/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PullRequest",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v27/*: any*/),
                                      (v114/*: any*/),
                                      (v115/*: any*/)
                                    ],
                                    "type": "Commit",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "ClosedEvent",
                            "abstractKey": null
                          },
                          (v116/*: any*/),
                          (v117/*: any*/),
                          (v118/*: any*/),
                          (v119/*: any*/),
                          (v120/*: any*/),
                          (v121/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v123/*: any*/)
                            ],
                            "type": "BlockedByAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v123/*: any*/)
                            ],
                            "type": "BlockedByRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v124/*: any*/),
                            "type": "BlockingAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v124/*: any*/),
                            "type": "BlockingRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "deletedCommentAuthor",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  (v17/*: any*/),
                                  (v19/*: any*/),
                                  (v18/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CommentDeletedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v125/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": "blockedUser",
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserBlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v127/*: any*/),
                            "type": "SubIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v127/*: any*/),
                            "type": "SubIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v128/*: any*/),
                            "type": "ParentIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v128/*: any*/),
                            "type": "ParentIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v129/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": (v63/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Commit",
                                "kind": "LinkedField",
                                "name": "commit",
                                "plural": false,
                                "selections": [
                                  (v130/*: any*/),
                                  (v131/*: any*/),
                                  (v132/*: any*/),
                                  (v27/*: any*/),
                                  (v114/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "repository",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v68/*: any*/),
                                      (v133/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v134/*: any*/),
                            "type": "ConnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "fromRepository",
                                "plural": false,
                                "selections": [
                                  (v54/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TransferredEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v134/*: any*/),
                            "type": "DisconnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicate",
                                "plural": false,
                                "selections": (v74/*: any*/),
                                "storageKey": null
                              },
                              (v135/*: any*/),
                              (v136/*: any*/),
                              (v137/*: any*/)
                            ],
                            "type": "MarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v135/*: any*/),
                              (v136/*: any*/)
                            ],
                            "type": "UnmarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConvertedToDiscussionEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v138/*: any*/)
                            ],
                            "type": "AddedToProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v138/*: any*/)
                            ],
                            "type": "RemovedFromProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v138/*: any*/),
                              (v139/*: any*/),
                              (v140/*: any*/)
                            ],
                            "type": "ProjectV2ItemStatusChangedEvent",
                            "abstractKey": null
                          },
                          (v141/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v142/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "IssueTypeAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v142/*: any*/)
                            ],
                            "type": "IssueTypeRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v142/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueType",
                                "kind": "LinkedField",
                                "name": "prevIssueType",
                                "plural": false,
                                "selections": (v98/*: any*/),
                                "storageKey": null
                              },
                              (v77/*: any*/)
                            ],
                            "type": "IssueTypeChangedEvent",
                            "abstractKey": null
                          },
                          (v143/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useTimelineItemsBackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "backTimelineItems",
                "args": (v4/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v21/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Issue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": (v144/*: any*/),
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v10/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              (v27/*: any*/),
                              (v9/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "App",
                                "kind": "LinkedField",
                                "name": "viaApp",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v27/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v40/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsorship",
                                "kind": "LinkedField",
                                "name": "authorToRepoOwnerSponsorship",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v43/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*: any*/),
                              (v45/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserContentEdit",
                                "kind": "LinkedField",
                                "name": "lastUserContentEdit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "editor",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v27/*: any*/),
                                      (v11/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "pinnedBy",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v51/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReactionGroup",
                                "kind": "LinkedField",
                                "name": "reactionGroups",
                                "plural": true,
                                "selections": [
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v57/*: any*/),
                                    "concreteType": "ReactorConnection",
                                    "kind": "LinkedField",
                                    "name": "reactors",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v58/*: any*/),
                                          (v59/*: any*/),
                                          (v60/*: any*/),
                                          (v61/*: any*/),
                                          (v145/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "reactors(first:5)"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v62/*: any*/)
                            ],
                            "type": "IssueComment",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v146/*: any*/),
                                "storageKey": null
                              },
                              (v64/*: any*/),
                              (v65/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": "innerSource",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v149/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CrossReferencedEvent",
                            "abstractKey": null
                          },
                          (v78/*: any*/),
                          (v79/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v80/*: any*/),
                                  (v84/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v85/*: any*/),
                                  (v145/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v77/*: any*/)
                            ],
                            "type": "AssignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v84/*: any*/),
                                  (v85/*: any*/),
                                  (v86/*: any*/),
                                  (v87/*: any*/),
                                  (v145/*: any*/),
                                  (v80/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "UnassignedEvent",
                            "abstractKey": null
                          },
                          (v89/*: any*/),
                          (v90/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v150/*: any*/),
                              (v99/*: any*/),
                              (v100/*: any*/),
                              (v75/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "IssueFieldAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v150/*: any*/),
                              (v101/*: any*/),
                              (v102/*: any*/),
                              (v103/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "IssueFieldChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v150/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "IssueFieldRemovedEvent",
                            "abstractKey": null
                          },
                          (v105/*: any*/),
                          (v106/*: any*/),
                          (v108/*: any*/),
                          (v109/*: any*/),
                          (v110/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v67/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicateOf",
                                "plural": false,
                                "selections": (v149/*: any*/),
                                "storageKey": null
                              },
                              (v111/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "closer",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v113/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v27/*: any*/),
                                      (v23/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v15/*: any*/),
                                          (v147/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PullRequest",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v27/*: any*/),
                                      (v114/*: any*/),
                                      (v151/*: any*/)
                                    ],
                                    "type": "Commit",
                                    "abstractKey": null
                                  },
                                  (v145/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "ClosedEvent",
                            "abstractKey": null
                          },
                          (v116/*: any*/),
                          (v117/*: any*/),
                          (v118/*: any*/),
                          (v119/*: any*/),
                          (v120/*: any*/),
                          (v121/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v153/*: any*/)
                            ],
                            "type": "BlockedByAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v153/*: any*/)
                            ],
                            "type": "BlockedByRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v154/*: any*/),
                            "type": "BlockingAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v154/*: any*/),
                            "type": "BlockingRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "deletedCommentAuthor",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  (v17/*: any*/),
                                  (v19/*: any*/),
                                  (v18/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CommentDeletedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v125/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": "blockedUser",
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v15/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserBlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v156/*: any*/),
                            "type": "SubIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v156/*: any*/),
                            "type": "SubIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v157/*: any*/),
                            "type": "ParentIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v157/*: any*/),
                            "type": "ParentIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v129/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": (v146/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Commit",
                                "kind": "LinkedField",
                                "name": "commit",
                                "plural": false,
                                "selections": [
                                  (v130/*: any*/),
                                  (v131/*: any*/),
                                  (v132/*: any*/),
                                  (v27/*: any*/),
                                  (v114/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "repository",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v147/*: any*/),
                                      (v133/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v158/*: any*/),
                            "type": "ConnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "fromRepository",
                                "plural": false,
                                "selections": [
                                  (v54/*: any*/),
                                  (v27/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TransferredEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v158/*: any*/),
                            "type": "DisconnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicate",
                                "plural": false,
                                "selections": (v149/*: any*/),
                                "storageKey": null
                              },
                              (v159/*: any*/),
                              (v136/*: any*/),
                              (v137/*: any*/)
                            ],
                            "type": "MarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v159/*: any*/),
                              (v136/*: any*/)
                            ],
                            "type": "UnmarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v23/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConvertedToDiscussionEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v160/*: any*/)
                            ],
                            "type": "AddedToProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v160/*: any*/)
                            ],
                            "type": "RemovedFromProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v160/*: any*/),
                              (v139/*: any*/),
                              (v140/*: any*/)
                            ],
                            "type": "ProjectV2ItemStatusChangedEvent",
                            "abstractKey": null
                          },
                          (v141/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v162/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "IssueTypeAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v162/*: any*/)
                            ],
                            "type": "IssueTypeRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v162/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueType",
                                "kind": "LinkedField",
                                "name": "prevIssueType",
                                "plural": false,
                                "selections": (v161/*: any*/),
                                "storageKey": null
                              },
                              (v77/*: any*/)
                            ],
                            "type": "IssueTypeChangedEvent",
                            "abstractKey": null
                          },
                          (v145/*: any*/),
                          (v143/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "57512e908279650f89aa504049505f3e",
    "metadata": {},
    "name": "useTimelineItemsBackQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a95b373bcb6a0d2cdc01db78b69e2c11";

export default node;
